import { Navigate } from 'react-router-dom'

/**
 * Report navigation = 2 màn riêng (ReportsPage = Dashboards, ReportValuePage =
 * Inputs). Section-pointer + last-tab của Inputs nhớ client-side qua localStorage
 * (không thêm scope backend / khỏi restart). Tab trong Dashboards vẫn nhớ
 * server-side qua pref `('dashboard','navigation')`.
 */
export const REPORT_LAST_SECTION_KEY = 'tlc:report:lastSection'
export const REPORT_INPUTS_LAST_TAB_KEY = 'tlc:report:inputs:lastTab'

const VALID_INPUTS_TABS = ['exposure', 'cashflows', 'misa-mapping'] as const

/** `/report` → SECTION cuối user mở (Dashboards vs Inputs). Fallback Dashboards. */
export default function ReportIndexRedirect() {
  const section = localStorage.getItem(REPORT_LAST_SECTION_KEY)
  const target = section === 'inputs' ? '/report/inputs' : '/report/dashboards'
  return <Navigate to={target} replace />
}

/** `/report/inputs` → tab Inputs cuối user mở. Fallback `exposure`. */
export function ReportInputsIndexRedirect() {
  const saved = localStorage.getItem(REPORT_INPUTS_LAST_TAB_KEY)
  const tab = saved && (VALID_INPUTS_TABS as readonly string[]).includes(saved) ? saved : 'exposure'
  return <Navigate to={`/report/inputs/${tab}`} replace />
}
